export default "__VITE_ASSET__61057432__"